import * as React from "react";
import { forwardRef } from "react";
const SvgInDemandProducts = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-trending-down", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("polyline", { points: "22 17 13.5 8.5 8.5 13.5 2 7" }), /* @__PURE__ */ React.createElement("polyline", { points: "16 17 22 17 22 11" }));
const ForwardRef = forwardRef(SvgInDemandProducts);
export { ForwardRef as ReactComponent };
